import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import InputMask from 'react-input-mask';

class FlightReportOfflineStaffsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      flight_report_id: null,
      staff_id: null,
      duty_id: null,
      arrival: null,
      date: this.props.flight_report.date_str,
      flight_report: this.props.flight_report,
      flight_report_staffs: this.props.flight_report_staffs,
      staffs_select: [],
      duties_select: [],
    };

    this.add = this.add.bind(this);
    this.deleteStaff = this.deleteStaff.bind(this);
  }
  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.flight_report_staffs) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        flight_report_id: newProps.flight_report_id,
        flight_report_staffs: newProps.flight_report_staffs,
        staffs_select: newProps.staffs_select,
        duties_select: newProps.duties_select,
        flight_report: newProps.flight_report,
        date: newProps.flight_report.date_str,
        loaded: 1,
      });
    }
  }

  add (event) {
    event.preventDefault();
    if(navigator.onLine) {
      this.props.handleAlert('', '', 'open');
      let arrival = this.state.date + ' ' + this.state.arrival_hour;
      var datasave = {
        flight_report_id: this.state.flight_report_id,
        staff_id: this.state.staff_id,
        duty_id: this.state.duty_id,
        arrival: arrival,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.setState({staff_id: null, duty_id: null});
        }).catch((error) => {
          console.error(error);
        });
      });
    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }
    
  }

  deleteStaff (staff_id) {
    if(navigator.onLine) {
      if (window.confirm('Tem certeza que deseja excluir esse tripulante? Ele será excluido de todos os trechos.')) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          staff_id: staff_id,
          flight_report_id: this.state.flight_report_id,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/tripulante', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h4 className="page-title">Tripulantes cadastrados</h4>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th style={{width: '380px'}}>Nome</th>
          <th>CANAC</th>
          <th>SISPAT</th>
          <th>FB</th>
          <th>Apresentação</th>
        </tr>
      </thead>
      <tbody>
      {Object.keys(self.state.flight_report_staffs).map(function(k) {
        var srls = self.state.flight_report_staffs[k];
        return (
          <tr>
            <td style={{width: '380px'}}>{srls.name}</td>
            <td>{srls.canac}</td>
            <td>{srls.sispat}</td>
            <td>{srls.duty}</td>
            <td>{srls.arrival}</td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
</div>
    );
  }
}

export default FlightReportOfflineStaffsTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportOfflineStaffsTab.js